const rawDecimals = process.env.REACT_APP_TOKEN_DECIMALS;
const parsedDecimals = Number(rawDecimals);

export const TOKEN_SYMBOL: string = process.env.REACT_APP_TOKEN_SYMBOL || 'USDC';

export const TOKEN_DECIMALS: number =
  rawDecimals !== undefined && rawDecimals !== '' && !Number.isNaN(parsedDecimals)
    ? parsedDecimals
    : 6;

export const formatTokenAmount = (amount: number): string =>
  amount.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: TOKEN_DECIMALS,
  });
